export class GetNotebookContent200Response {
    'content';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "content",
            "baseName": "content",
            "type": "{ [key: string]: any; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetNotebookContent200Response.attributeTypeMap;
    }
    constructor() {
    }
}
